export const translateToIcon = inputurl => {
  return new Promise(resolve => {
    const canvas = document.createElement("canvas");
    canvas.width = 64;
    canvas.height = 64;
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.setAttribute("crossOrigin", "anonymous");
    img.onload = function () {
      const width = img.width;
      const height = img.height;
      const ratio = width / height;
      const x = ratio >= 1 ? 0 : (64 - 64 * ratio) / 2;
      const y = ratio >= 1 ? (64 - 64 / ratio) / 2 : 0;
      ctx.drawImage(img, x, y, ratio >= 1 ? 64 : 64 * ratio, ratio >= 1 ? 64 / ratio : 64);
      const dataURL = canvas.toDataURL("image/png", 1);
      resolve(dataURL);
    };
    img.onerror = function () {
      resolve(undefined);
    };
    img.src = inputurl + "?time=" + new Date().valueOf();
  });
};
